<template>
  <Card class="panel shadow-premium">
    <template v-if="!hideHeader" #title>
      <div class="panel-header-content">
        <span class="panel-title">{{ title }}</span>
        <ul class="panel-icons">
          <slot name="icons"></slot>
        </ul>
      </div>
    </template>
    <template #content>
      <div class="panel-body-content">
        <slot />
      </div>
    </template>
  </Card>
</template>
<script>
import Card from 'primevue/card'

export default {
  components: {
    Card
  },
  props: {
    title: String,
    hideHeader: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped>
.panel {
  --panel-border-radius: 12px;

  position: relative;
  border-radius: var(--panel-border-radius);
  background-color: var(--color-slate-900) !important;
  border: 1px solid var(--color-slate-800) !important;
  color: var(--color-slate-100) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.panel:hover {
  border-color: var(--color-indigo-500) !important;
  box-shadow: 0 20px 40px -15px rgba(26, 95, 210, 0.15), 0 10px 30px -10px rgba(0, 0, 0, 0.7);
}

:deep(.p-card-body) {
  padding: 0 !important;
}

:deep(.p-card-title) {
  margin: 0 !important;
  padding: 0.5rem 1rem;
  background-color: var(--color-slate-955) !important;
  border-bottom: 1px solid var(--color-slate-800) !important;
}

.panel-header-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.panel-title {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--color-slate-100);
}

.panel-icons {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}

.panel-body-content {
  padding: 0.35rem 1rem 0.75rem 1rem;
  color: var(--color-slate-100);
  background-color: transparent !important;
}
</style>

